import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";

function init() {
	OcmMessenger.subscribe(messengerPublicationTypes.UPDATED_MINI_CART, _updateMiniCartCount);
}

async function _updateMiniCartCount({ data }) {
	if (typeof data === "number") {
		_setCount(data);
		return;
	}

	try {
		const response = await fetch("/rest/mini-cart/count/", {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		});
		if (!response.ok) throw new Error("MiniCart request failed");

		const count = await response.json();
		_setCount(count);
	} catch (error) {
		console.error("MiniCart count error", error);
	}
}

function _setCount(count) {
	const badgeElements = document.querySelectorAll(".js-miniCartCounter-badge");
	badgeElements.forEach((item) => {
		item.textContent = count;
		// TUB-21493 Colored Cart Badge A/B-Test
		if (item.dataset.count !== undefined) item.dataset.count = count;
	});
}

export { init };
